export default [
    () => {
        return {
            restrict: "A",
            require: "^appPick",
            link: ($scope, $element, $attr, ctrl) => {
                const direction = $attr.appPickTrigger;

                const trigger = () => {
                    ctrl.trigger(direction);
                };

                $element.bind("click", trigger);
            }
        };
    }
];
